var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1753,
    cy: 10.6206,
    rx: 10.7046,
    ry: 10.3885,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1736 8.03062C17.1016 7.77041 16.9612 7.53317 16.7663 7.34255C16.5715 7.15193 16.3289 7.01456 16.0629 6.94414C15.089 6.68433 11.1692 6.68433 11.1692 6.68433C11.1692 6.68433 7.24929 6.69219 6.27535 6.952C6.00932 7.02243 5.76679 7.1598 5.57192 7.35043C5.37704 7.54107 5.23662 7.77831 5.16464 8.03853C4.87005 9.7312 4.75578 12.3104 5.17273 13.9354C5.24472 14.1956 5.38514 14.4328 5.58002 14.6235C5.77489 14.8141 6.01742 14.9514 6.28344 15.0219C7.25737 15.2817 11.1772 15.2817 11.1772 15.2817C11.1772 15.2817 15.097 15.2817 16.0709 15.0219C16.3369 14.9515 16.5795 14.8141 16.7743 14.6235C16.9692 14.4328 17.1097 14.1956 17.1817 13.9354C17.4924 12.2403 17.5881 9.66267 17.1736 8.03062Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0703 12.4162L13.0233 10.9832L10.0703 9.55029V12.4162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.fc863453c58f1da332f36b99705483a9.svg";
export { ForwardRef as ReactComponent };